import { createContext, useReducer } from 'react';
import { wizardReducer, initialState } from './wizardReducer';

export const WizardContext = createContext(null);

export const WizardProvider = ({ children, onComplete, onClose }) => {
  const [state, dispatch] = useReducer(wizardReducer, initialState);

  const callbacks = {
    onComplete,
    onClose,
  };

  return (
    <WizardContext.Provider value={{ state, dispatch, callbacks }}>
      {children}
    </WizardContext.Provider>
  );
};

export default WizardProvider;
